import { render, staticRenderFns } from "./FactorManagement.vue?vue&type=template&id=aefaa402&scoped=true"
import script from "./FactorManagement.vue?vue&type=script&lang=js"
export * from "./FactorManagement.vue?vue&type=script&lang=js"
import style0 from "./FactorManagement.vue?vue&type=style&index=0&id=aefaa402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefaa402",
  null
  
)

export default component.exports